import { FormUnitInput } from "../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import {
  ENERGY_UNIT_TYPES_OPTIONs,
  POWER_UNIT_TYPES_OPTIONs,
  VOLUME_UNIT_TYPES_OPTIONs,
  WEIGHT_UNIT_TYPES_OPTIONs
} from "../../../../config/constants";
import { valueGraterThanZero } from "../../../../utils/utils";

const Specific = ({ control, existingProcess, index, dataTypeIsSpecific, countries }: any) => {
  const getFieldName = (field: string) => {
    return index !== undefined && index !== null ? `processes.${index}.${field}` : field;
  };

  return (
    <div className="tw-grid tw-w-full tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
        <FormUnitInput
          control={control}
          name={getFieldName("input")}
          label="Input"
          unitName={getFieldName("inputUnit")}
          placeholder="0"
          unitOptions={WEIGHT_UNIT_TYPES_OPTIONs}
          required={dataTypeIsSpecific}
          errorMessage="Input is required"
          validate={{
            valueCheck: (v: any) => valueGraterThanZero(v) || "Input must be grater than 0"
          }}
          disabled={existingProcess}
        />
        <FormUnitInput
          control={control}
          name={getFieldName("output")}
          label="Output"
          unitName={getFieldName("outputUnit")}
          placeholder="0"
          unitOptions={WEIGHT_UNIT_TYPES_OPTIONs}
          required={dataTypeIsSpecific}
          errorMessage="Output is required"
          validate={{
            valueCheck: (v: any) => valueGraterThanZero(v) || "Output must be greater than 0"
          }}
          disabled={existingProcess}
        />
        <FormUnitInput
          control={control}
          name={getFieldName("sideStream")}
          label="Bio waste/side stream"
          unitName={getFieldName("sideStreamUnit")}
          placeholder="0"
          unitOptions={WEIGHT_UNIT_TYPES_OPTIONs}
          disabled={existingProcess}
        />
        <FormUnitInput
          control={control}
          name={getFieldName("electricity")}
          label="Electricity (per input amount)"
          required={dataTypeIsSpecific}
          unitName={getFieldName("electricityUnit")}
          placeholder="0"
          unitOptions={POWER_UNIT_TYPES_OPTIONs}
          validate={{
            valueCheck: (v: any) => valueGraterThanZero(v) || "Electricity must be greater than 0"
          }}
          disabled={existingProcess}
        />
        <FormUnitInput
          control={control}
          name={getFieldName("heat")}
          unitName={getFieldName("heatUnit")}
          label="Heat (per input amount)"
          placeholder="0"
          unitOptions={ENERGY_UNIT_TYPES_OPTIONs}
          disabled={existingProcess}
        />
        <FormUnitInput
          control={control}
          name={getFieldName("wastewater")}
          label="Water (per input amount)"
          unitName={getFieldName("wastewaterUnit")}
          placeholder="0"
          unitOptions={VOLUME_UNIT_TYPES_OPTIONs}
          disabled={existingProcess}
        />
      </div>
  );
};

export default Specific;
